// appels query-key factories (TanStack Query)
// The ONLY thing another module may import from here.

/** One appel (`GET /appels/{id}/`). Saving a step or creating an appel invalidates `all`. */
export const appelKeys = {
  all: ["appels"] as const,
  detail: (id: string) => [...appelKeys.all, "detail", id] as const,
};
